import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { addKioskVoucher } from "@app/store/actions/orderActions"
import { Modal, useModal } from "@tecreation/funnel-components"
import { useEffect, useRef } from "react"

export function EmployeePriceModal({ voucher }) {
	const { hideModal } = useModal()
	const ref = useRef()

	useEffect(() => {
		if (ref.current) {
			ref.current.focus()
		}
	}, [])

	return (
		<Modal>
			<Modal.Closer />
			<Modal.Header>Gutscheinwert</Modal.Header>
			<Modal.Body>
				<div style={{ width: "400px" }}>
					<Input label="Preis" inputRef={ref} className="mt-3" type="number" />
				</div>
			</Modal.Body>
			<Modal.Footer className="flex flex-justify-between">
				<Button style="danger" onClick={hideModal}>
					Abbrechen
				</Button>
				<Button
					style="secondary"
					onClick={() => {
						try {
							let value = Number(ref.current.value)
							addKioskVoucher({
								...voucher,
								price: value,
							})
							hideModal()
						} catch (e) {
							// eslint-disable-next-line no-console
							console.error(e)
						}
					}}
				>
					Hinzufügen
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
